import React, { useState } from 'react';

export default function VotePanel({ emit, gameState, playerId, hasVoted }) {
  const [submitting, setSubmitting] = useState(false);
  const [voted, setVoted] = useState(false);

  if (!gameState || gameState.phase !== 'voting') return null;

  const actuallyVoted = hasVoted || voted;

  const handleVote = async (vote) => {
    if (submitting || actuallyVoted) return;
    setSubmitting(true);
    const res = await emit('player:vote', { vote });
    setSubmitting(false);
    if (res.success) {
      setVoted(true);
    }
  };

  if (actuallyVoted) {
    return (
      <div className="vote-submitted">
        <span className="checkmark">{'\u2713'}</span>
        Vote submitted! Waiting for all players...
        <div className="text-muted mt-8" style={{ fontSize: '0.8rem' }}>
          {gameState.votesSubmitted} / {gameState.playerCount} votes in
        </div>
      </div>
    );
  }

  const leader = gameState.players.find(p => p.id === gameState.leaderId);
  const teamNames = gameState.proposedTeam.map(
    tid => gameState.players.find(p => p.id === tid)?.name || '?'
  );

  return (
    <div className="vote-panel">
      <div className="text-center mb-8">
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
          {leader?.name}'s proposed team:
        </div>
        <div style={{ fontWeight: 700, marginTop: '4px' }}>
          {teamNames.join(', ')}
        </div>
      </div>
      <div className="vote-buttons">
        <button
          className="btn btn-approve"
          onClick={() => handleVote('approve')}
          disabled={submitting}
        >
          Approve
        </button>
        <button
          className="btn btn-reject"
          onClick={() => handleVote('reject')}
          disabled={submitting}
        >
          Reject
        </button>
      </div>
    </div>
  );
}
